export default "assets/images/333d69c92e8b02ed8da1f4f539b18f3f.gif";